export const COOKIE_PREFIX = 'treez_';

export enum CookiesNames {
  _CUSTOMER_TYPE = `${COOKIE_PREFIX}customerType`,
  _TERMS_ACCEPTED = `${COOKIE_PREFIX}terms_accepted`,
  _SELECTED_STORE_ID = `${COOKIE_PREFIX}selectedStoreId`,
  _FULFILLMENT_TYPE = `${COOKIE_PREFIX}fulfillmentType`,
  /**
   * Per-store age gate acceptance map: `{ [storeShortName]: true }`. Additive to the global
   * `_TERMS_ACCEPTED` window. Filled by `/age-gate`, on accept and on auto-accept.
   */
  _STORE_TERMS = `${COOKIE_PREFIX}store_terms`,
}
